import { render, staticRenderFns } from "./loginData.vue?vue&type=template&id=44c2a6af&"
import script from "./loginData.vue?vue&type=script&lang=js&"
export * from "./loginData.vue?vue&type=script&lang=js&"
import style0 from "./loginData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports